<template>
  <div class="">
    <img :src="logoHeader" alt="Logo" class="header">
    <form-wizard color="rgba(var(--vs-primary), 1)" :title="null" :subtitle="null" :hide-buttons="true" ref="wizard">
        <tab-content title="Contacto" class="mb-5">
          <Contacto v-on:nextTab="next($event)"/>
          <br>
        </tab-content>
        <tab-content title="Datos del crédito" class="mb-5">
          <Credito v-on:nextTab="next($event)"/>
          <br>
        </tab-content>
        <tab-content title="Final" class="mb-5">
          <div class="vx-col w-full md:w-3/3 sm:w-2/2 mb-base">
            <vx-card class="text-center cursor-pointer">
              <img src="@/assets/images/pages/graphic-2.png" alt="graphic" width="180" class="mx-auto mb-4">
              <h4 class="mb-2">Un asesor se pondrá en contacto contigo</h4>
              <small>En las próximas 6 horas hábiles (Lunes a viernes de 8 am a 6pm)</small>
            </vx-card>
          </div>
          <br>
        </tab-content>
    </form-wizard>
  </div>
</template>

<script>
import { mapActions, mapMutations } from 'vuex';
import {FormWizard, TabContent, WizardStep, WizardButton} from 'vue-form-wizard'
import 'vue-form-wizard/dist/vue-form-wizard.min.css'
import Destinos from '@/views/Destinos.vue'
import Credito from '@/views/Credito.vue'
import Contacto from '@/views/Contacto.vue'
export default {
  data() {
    return {
      logoHeader:'https://cotizador.socasesores.com/uploads/5446b9a8-c633-4c9e-bb24-81113d75759a.jpg',
      key:'',
    }
  },
  mounted(){
    this.getApiKey(this.$route.params)
    this.key=this.$store.state.key
    this.getValues()
  },
  methods: {
    ...mapMutations(['getApiKey']),
    ...mapActions(['nextTab']),
    next(){
      this.nextTab(this.$refs.wizard)
    },
    getValues(){
      let objRequestDameSolicitante = {
        strApiKey: this.key,
        strMetodo: 'MisDatos',
      }
      this.$axios.post('/',objRequestDameSolicitante,{headers : {'Content-Type':'application/x-www-form-urlencoded; charset=UTF-8'}})
      .then(
        response => {
        if(response.data.intEstatus == 0){
          let data= response.data.objContenido
          if(data.WidgetColorPrimario !== '' && data.WidgetColorPrimario !== null){
            this.$vs.theme({
              primary:data.WidgetColorPrimario
            })
          }
          if(data.WidgetImagen !== '' && data.WidgetImagen !== null){
            this.logoHeader = "https://cotizador.socasesores.com/uploads/"+data.WidgetImagen
            }
          }
        }
      ).catch(function (error) {
        console.log(error)
      })
    }
  },
  components: {
    FormWizard,
    TabContent,
    Destinos,
    Credito,
    Contacto,
    WizardStep,
    WizardButton
  }
}
</script>
<style media="screen">
  .header{
    display: block;
    margin-left: auto;
    margin-right: auto;
     width: 25%; 
     height: 50%;
    margin-top: 0%;
    /* margin-bottom: 10%; */
  }
  .router-content{
    margin-top: 0% !important;
  }
</style>
